<template>
  <div class="messageRecordDetail">messageRecordDetail</div>
</template>

<script>
export default {
  name: "messageRecordDetail",
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.messageRecordDetail{
    background: #fff;
}
</style>
